import React from 'react';
import { useSelector } from 'react-redux';

export default function BalanceLimitCardV2({ migrationModal = () => { return } }) {
    const configs = useSelector(state => state.config);

    const maxUserBalance = configs ?
        Number(configs.max_user_balance.split(' ')[0]).toFixed(0)
        :
        '5000';

    var title = `YOU HAVE ${maxUserBalance} OR MORE QUDO`;
    var subtitle = `Currently you have more than ${maxUserBalance} QUDO in a wallet that is NOT managed by you.`;
    var message = 'Not your KEYS, not your TOKENS!';

    var style = {
        color: '#fbfafb',
        backgroundColor: '#F44336'
    };

    var messageStyle = {
        borderBottom: '1px solid #fbfafb',
        borderTop: '1px solid #fbfafb',
        fontWeight: '500',
        textAlign: 'center',
        lineHeight: '2'
    };

    return (
        <>
            <div
                style={style}
                className={`card roundcard shadow enable-click`}
                onClick={() => migrationModal()}
            >
                <div className="card-body p-4">
                    <div style={{ borderBottom: '1px solid rgba(251, 250, 251, 0.5)' }}>
                        <h2 className="d-inline-block">
                            {title}
                        </h2>
                    </div>

                    <div className='pt-3 pb-2'>
                        <span>
                            {subtitle}
                        </span>
                    </div>

                    <div style={messageStyle}>
                        {message}
                    </div>
                    <div className='mt-2' style={{
                        fontWeight: 'bold',
                        textDecoration: 'underline',
                        textAlign: 'center'
                    }}>
                        Click here to take control of your account.
                    </div>
                </div>
            </div>

        </>
    );

}
